/**
 * @param {number} ms
 * @return {Promise<any>}
 */
export const delay = ms => new Promise((_) => {
  setTimeout(_, ms);
});

export function readImageAsDataUrl(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onload = (e) => {
      const { result } = e.target;
      if (result) {
        resolve(result);
      }
    };

    reader.onabort = () => reject(new Error('File reading aborted'));
    reader.onerror = () => reject(new Error('Failed to read file'));

    reader.readAsDataURL(file);
  });
}

export function redirectToUserSectionByAttributes($router, attributes) {
  const adminViews = attributes.filter(item => !!item && item.startsWith('ADMIN_'));
  let path = null;

  if (adminViews.includes('ADMIN_PRODUCTS')) {
    path = '/dashboard';
  } else if (adminViews.includes('ADMIN_EMPLOYEES')) {
    path = '/employees-home';
  } else if (adminViews.includes('ADMIN_CLIENTS')) {
    path = '/clients-home';
  } else if (adminViews.includes('ADMIN_SALES')) {
    path = '/sales';
  } else if (adminViews.includes('ADMIN_SALES_ORDERS')) {
    path = '/sales-orders';
  } else if (adminViews.includes('ADMIN_PURCHASE_ORDERS')) {
    path = '/quotations';
  } else if (adminViews.includes('ADMIN_KITS')) {
    path = '/kits';
  } else if (adminViews.includes('ADMIN_CATALOGS')) {
    path = '/tags-home';
  } else if (adminViews.includes('ADMIN_PROMOTIONS')) {
    path = '/specials-discount-home';
  } else if (adminViews.includes('ADMIN_INVENTORY')) {
    path = '/stores-inventory';
  } else if (adminViews.includes('ADMIN_SALES_ORDERS_ADMIN')) {
    path = '/dashboard';
  } else if (adminViews.includes('ADMIN_DRIVER_MAP')) {
    path = '/drivers-home';
  }

  if (path) {
    $router.push(path);
  }
}

/**
 * @param {any} context
 * @param {Object} options
 * @returns {Promise<SweetAlertResult>}
 */
export async function showAlert(context, options) {
  if (!context.$swal || !options) {
    return Promise.reject('Undefined');
  }

  return context.$swal(options);
}

export function cleanPhoneNumber(value) {
  const v = !value ? '' : value.toString();

  if (!v) {
    return '';
  }

  return value.replace(/\D/g, '');
}

export function formatPhoneNumber(value) {
  const v = cleanPhoneNumber(value);

  // if invalid value, return same value
  if (v.length !== 10) {
    return v;
  }

  const pattern = '(###) ###-####';
  let i = 0;

  // eslint-disable-next-line no-plusplus,no-unused-vars
  return pattern.replace(/#/g, _ => v[i++]);
}

export function validateEmail(email) {
  const emailRegexp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/;
  return emailRegexp.test(email);
}

export function validatePhoneNumber(phoneNumber) {
  const phoneRegexp = /^\(\d{3}\)\s\d{3}-\d{4}$/;
  return phoneRegexp.test(phoneNumber);
}

/**
 * Format timestamp to dd/mm/yyyy
 * @param {number} timestamp
 * @returns {string}
 */
export function formatTimestampToDate(timestamp) {
  const date = new Date(timestamp);
  const day = String(date.getDate()).padStart(2, '0'); // Lấy ngày và thêm số 0 nếu cần
  const month = String(date.getMonth() + 1).padStart(2, '0'); // Lấy tháng (bắt đầu từ 0) và thêm số 0 nếu cần
  const year = date.getFullYear(); // Lấy năm

  return `${day}/${month}/${year}`;
}


/**
 * Compress image before upload
 * @param {File} file - Image file to compress
 * @param {number} maxWidth - Maximum width (default: 1200)
 * @param {number} maxHeight - Maximum height (default: 1200)
 * @param {number} quality - Image quality 0-1 (default: 0.8)
 * @returns {Promise<Blob>} Compressed image blob
 */
export function compressImage(file, maxWidth = 1200, maxHeight = 1200, quality = 0.8) {
  return new Promise((resolve, reject) => {
    // Check if file is an image
    if (!file.type.startsWith('image/')) {
      resolve(file);
      return;
    }

    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    const img = new Image();
    img.onload = () => {
      try {
        const { width, height } = img;

        // Calculate scale factor
        const scaleWidth = maxWidth / width;
        const scaleHeight = maxHeight / height;
        const scale = Math.min(scaleWidth, scaleHeight, 1);

        const newWidth = Math.floor(width * scale);
        const newHeight = Math.floor(height * scale);

        // Set canvas dimensions
        canvas.width = newWidth;
        canvas.height = newHeight;

        ctx.imageSmoothingEnabled = true;
        ctx.imageSmoothingQuality = 'high';

        ctx.drawImage(img, 0, 0, newWidth, newHeight);

        canvas.toBlob(
          (blob) => {
            // Cleanup
            URL.revokeObjectURL(img.src);
            if (blob) {
              resolve(blob);
            } else {
              reject(new Error('Canvas to Blob conversion failed'));
            }
          },
          file.type,
          quality,
        );
      } catch (error) {
        URL.revokeObjectURL(img.src);
        reject(error);
      }
    };
    img.onerror = () => {
      URL.revokeObjectURL(img.src);
      reject(new Error('Failed to load image'));
    };
    img.src = URL.createObjectURL(file);
  });
}
